import { render } from "./ManagerCreatePage.vue?vue&type=template&id=8c5a760a"
import script from "./ManagerCreatePage.vue?vue&type=script&lang=js"
export * from "./ManagerCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__